export default class Role {
    static Admin = 'Admin';
    static User = 'User';
}